import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSnapchatComponent } from './simple-icons-snapchat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSnapchatComponent ],
    exports:      [ SimpleIconsSnapchatComponent ],
    bootstrap:    []
})
export class SimpleIconsSnapchatModule {}
